import { DocumentTemplateModel } from './documentTemplateModel';

export class DocumentTemplateViewModel extends DocumentTemplateModel{
    public caseTypeDocumentTemplates: string;
}
